const FormFile = ({
    fileInputValue,
    fieldName,
    handleFileChange,
    label,
    allowMultiple = false,
    errors
}: {
    fileInputValue: any;
    fieldName: string;
    handleFileChange: any;
    label?: string;
    allowMultiple?: boolean;
    errors?: any;
}) => {
    return (
        <div className="mb-3">
            <label htmlFor={fieldName} className="form-label">{label ? label : fieldName}</label>
            <input
                type="file"
                className={`form-control ${errors?.[fieldName] && 'is-invalid'}`}
                id={fieldName}
                value={fileInputValue}
                multiple={allowMultiple}
                onChange={handleFileChange} />
            {
                errors?.[fieldName] && (
                    <div className="invalid-feedback">
                        {errors?.[fieldName]}
                    </div>
                )
            }
        </div >
    );
};

export default FormFile;
